import * as React from 'react';
import { observer } from 'mobx-react';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import { IPayerOnboardingPageViewModel } from './payer-onboarding-page-view-model';
import Transition, { TransitionProps } from 'react-transition-group/Transition';
import { isFunction } from '../../Shared/utils/is-function';
import { PayerOnboardingViewForPageType } from './index';
import { PayerOnboardingUserAction } from '../payer-onboarding-user-actions';
import { PageError } from './page-error';

// TODO: read this from the less file
const pageTransitionDuration = parseInt('500', 10);

export interface IRouterProps {
	viewModel: IPayerOnboardingPageViewModel;
	setCurrentPageShouldBeVisible: () => void;
	raiseAction: (action: PayerOnboardingUserAction) => void;
	onError: (errorInfo: any, customData?: any) => void;
}

@observer
export class Router extends React.Component<IRouterProps, { hasPageError: boolean }> {

	constructor(props: any) {
		super(props);
		this.state = { hasPageError: false };
	}

	UNSAFE_componentWillReceiveProps(nextProps: IRouterProps) {
		if (!nextProps.viewModel.error) {
			this.setState({ hasPageError: false });
		}
	}

	componentDidCatch(error: any, reactErrorInfo: React.ErrorInfo) {
		this.props.setCurrentPageShouldBeVisible();
		window.scroll(0, 0);

		this.setState({ hasPageError: true });
		this.props.onError(error, reactErrorInfo);
	}

	render() {
		const { raiseAction, viewModel, setCurrentPageShouldBeVisible } = this.props;

		if (this.state.hasPageError) {
			return (
				<TransitionGroup>
					<ViewTransition
						key="page-error"
						setCurrentPageShouldBeVisible={setCurrentPageShouldBeVisible}
						vm={viewModel}
						raiseAction={raiseAction}
						view={PageError} />
				</TransitionGroup>
			);
		}

		const view = PayerOnboardingViewForPageType(viewModel.type);

		return (
			<TransitionGroup>
				<ViewTransition
					key={viewModel.type}
					setCurrentPageShouldBeVisible={setCurrentPageShouldBeVisible}
					vm={viewModel}
					raiseAction={raiseAction}
					view={view} />
			</TransitionGroup>
		);
	}
}

class ViewTransition extends React.Component<{
	vm: IPayerOnboardingPageViewModel;
	view: any;
	raiseAction: (action: PayerOnboardingUserAction) => void;
	setCurrentPageShouldBeVisible: () => void;
} & Partial<TransitionProps>> {
	render() {
		const { raiseAction, vm, view, setCurrentPageShouldBeVisible, ...rest } = this.props;

		return (
			<Transition  {...rest} timeout={pageTransitionDuration} onExit={this.onExit} onExited={this.onExited}>
				{(state: any) => React.createElement(view, {
					vm,
					raiseAction,
					transitionState: state,
				})}
			</Transition>
		);
	}

	private onExit = (node: HTMLElement) => {
		const { onExit, vm } = this.props;
		if (isFunction(onExit)) {
			onExit(node);
		}

		// disable user action channel on the current vm
		vm.blockUserActions();
	}

	private onExited = (node: HTMLElement) => {
		const { setCurrentPageShouldBeVisible, onExited } = this.props;
		if (isFunction(onExited)) {
			onExited(node);
		}
		setCurrentPageShouldBeVisible();
		window.scroll(0, 0);
	}
}
